import styled from "styled-components";

const sizes = {
  small: 1,
  medium: 2,
  large: 3,
};

const positions = {
  left: "padding-left",
  right: "padding-right",
  top: "padding-top",
  bottom: "padding-bottom",
};

const getVariant = (position, size, theme) => {
  const pos = positions[position];
  const finalSize = sizes[size];
  const s = theme.space[finalSize];
  return `${pos}:${s}`;
};

export const Spacer = styled.div`
  ${({ position, size, theme }) => getVariant(position, size, theme)}
`;
Spacer.defaultProps = {
  position: "top",
  size: "small",
};
